import { getCurrentIsoDate } from "@/utils/date.util";
import { SelectListOption } from "./common.type";
import { ShiftFormChannelType, ShiftFormPostType } from "./enums.type";
import { OfficeDefaultRateDto, OfficeHourDto } from "./office.type";
import { RatingDto } from "./rating.type";
import { ShiftGroupResponseDto } from "./shift-response.type";

export interface PayRateStatisticsDto {
  minPayRate: number;
  maxPayRate: number;
  averagePayRate: number;
}

export interface ShiftDeleteFormDataDto {
  reasons: SelectListOption[];
}

export interface ShiftGroupFormDataDto {
  positions: SelectListOption[];
  rates: OfficeDefaultRateDto[];
  hours: OfficeHourDto[];
  favoriteCount: number;
}

export interface ShiftGroupDto {
  id: number;
  shiftId: number;
  officeId: number;
  postedByUserId: number;
  status: number;
  name: string;
  posterFirstName: string;
  posterLastName: string;
  groupName: string;
  positionName: string;
  positionAbbreviation: string | null;
  payRate: number;
  speakSpanish: boolean;
  doubleChannel: boolean;
  favoriteOnly: boolean;
  postDate: Date;
  removeByDate: Date | null;
  startDateTime: Date;
  endDateTime: Date;
  responses: ShiftGroupResponseDto[];
  rating: RatingDto | null;
}

export interface ShiftDataDto {
  shiftStatuses: SelectListOption[];
  responseStatuses: SelectListOption[];
  ratingStatuses: SelectListOption[];
  positions: SelectListOption[];
  subscriptionStatuses: SelectListOption[];
}

export class ShiftGroupFormDto {
  id: number | null = null;
  shiftId: number | null = null;
  officeId = 0;
  postTo = ShiftFormPostType.All;
  dates: ShiftDateDto[] = [];
  breakTime = 0;
  positionId = 0;
  payRate: number | null = null;
  speakSpanish = false;
  channel: ShiftFormChannelType | null = null;
  postedByUserId = 0;
  acceptCounters = true;
}

export interface ShiftDateDto {
  date: string;
  timeIn: string;
  timeOut: string;
}

export class ShiftDeleteFormDto {
  id: number | null = null;
  reasonLookUpId: number | null = null;
}

export class ShiftFilterDto {
  officeId: number | null = null;
  startDate: string | null = getCurrentIsoDate();
  endDate: string | null = null;
}